import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { CategoryTags } from './components/CategoryTags';
import { Location } from './components/Location';
import { Scope } from './components/Scope';

export function PetitionData(): JSX.Element {
	return (
		<div className="mt-10 flex flex-col">
			<Text variant="heading" size="x-small" className="lowercase first-letter:uppercase" as="p">
				<Translate value="corgi.petition.edit.petition_data.heading" />
			</Text>
			<Flex sx={{ flexDirection: 'column', gap: 26, mb: 60 }}>
				<Scope />
				<Location />
				<CategoryTags />
			</Flex>
		</div>
	);
}
